import useSWR from 'swr';
import { fetchGet, schema, PATHNAME } from '../api/get-resources';
import { withManageConfig } from './utils';

export const useGetResources = (params) => {
  const result = schema.safeParse(withManageConfig(params));
  const key = result.success ? { PATHNAME, ...result.data } : null;
  return useSWR(key, fetchGet(result.data), {
    revalidateOnFocus: false,
    revalidateIfStale: false
  });
};
